import React, { useState } from 'react';
import { Button, Badge, ListGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';
import {
  AddParticipantButton,
  ModalAddParticipant,
  ModalAddOPIOperatorParticipant,
} from '../../../features';
import { CallType } from '../../../configs';
import { useAppSelector, VRIAppStateType } from '../../../core';
import { CallStatusType } from '../../../configs';
import { ThreeWayCallReDialRequest } from '../../../models/api/Call';
import { formatUSPhoneNumber } from '../../../utils/phoneNumberFormatting';

type Props = {
  isSidebarOpen: boolean;
  setIsSidebarOpen: (value: boolean) => void;
  setShowOutboundModal: (value: boolean) => void;
  handleHangup: Function;
  callinfo: any;
  onCallConferenceParticipant: (value: ThreeWayCallReDialRequest) => Promise<any>;
};

export function OpiConferenceSidebar({
  isSidebarOpen,
  setIsSidebarOpen,
  setShowOutboundModal,
  handleHangup,
  callinfo,
  onCallConferenceParticipant
}: Props) {


  const [showAddParticipantModal, setShowAddParticipantModal] = useState(false);

  const audioConferenceCalls = useAppSelector((state: VRIAppStateType) => state.audioCall.audioConferenceCalls);



  const getCallStatusLabel = (current?: CallStatusType, prev?: CallStatusType): string => {

     if (!current) return "waiting...";

    switch (current) {
      case CallStatusType.OutboundCallInitiated:
        return "Initiated";
      case CallStatusType.OutboundCallRinging:
        return "Ringing";
      case CallStatusType.OutboundCallReceived:
        return "Answered";
      case CallStatusType.OutboundCallNotAnswered:
        return "Not Answered";
      case CallStatusType.OutboundCallNotReceived:
        return "Voice Mail";
      case CallStatusType.OutboundCallCompleted:
        if (prev === CallStatusType.OutboundCallReceived) return "Hung Up";
        if (prev === CallStatusType.OutboundCallNotAnswered) return "Not Answered";
        return "Completed";
      default:
        return "waiting...";
    }
  };


  const callAgain = (phoneNumber: string) => {

    let value: ThreeWayCallReDialRequest = { phoneNumber: "", callSid: "" };
    value.phoneNumber = phoneNumber;
    value.callSid = callinfo.customParameters?.get("CallSid");
    onCallConferenceParticipant(value).then((a) => {
      // handleShow(false);
    });
    // dispatch(ActionAudioCall.UpsertAudioConferenceCall(
  };

  return (
    <>
      <div
        style={{
          position: 'fixed',
          top: 0,
          right: isSidebarOpen ? 0 : '-300px',
          width: '300px',
          height: '100%',
          backgroundColor: '#1e1e1e',
          color: '#ffffff',
          boxShadow: '-2px 0 5px rgba(0,0,0,0.5)',
          padding: '1rem',
          transition: 'right 0.3s ease',
          zIndex: 1000,
        }}
      >
        <button
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          style={{
            position: 'absolute',
            left: '-40px',
            top: '50%',
            transform: 'translateY(-50%)',
            width: '40px',
            height: '80px',
            borderRadius: '0.5rem 0 0 0.5rem',
            backgroundColor: '#333',
            color: '#fff',
            border: '1px solid #555',
            cursor: 'pointer',
            boxShadow: '-2px 0 5px rgba(0,0,0,0.5)',
            writingMode: 'vertical-rl',
            textOrientation: 'upright',
          }}
        >
          {isSidebarOpen ? '→' : '←'}
        </button>

        <div className="d-flex flex-column justify-content-between" style={{ height: "100%" }}>
          <div className="callees-section" style={{ flex: 1, overflowY: 'auto' }}>
            <h4 style={{ marginBottom: '1rem' }}>Callees</h4>
            <div style={{ maxHeight: 'calc(100% - 120px)', overflowY: 'auto' }}>

              <ListGroup variant="flush">
                {audioConferenceCalls?.map((callee) => (
                  <ListGroup.Item
                    key={callee.calledNumber}
                    className="d-flex justify-content-between align-items-center bg-dark text-light rounded mb-1"
                  >
                    <div className="d-flex flex-column align-items-start">
                      <div className="mb-1">{formatUSPhoneNumber(callee.calledNumber)}</div>
                      <Badge
                        className={
                          callee.status.current === CallStatusType.OutboundCallCompleted
                            ? 'custom-purple-badge'
                            : ''
                        }
                        variant={
                          callee.status.current === CallStatusType.OutboundCallInitiated ||
                            callee.status.current === CallStatusType.OutboundCallRinging
                            ? 'primary'
                            : callee.status.current === CallStatusType.OutboundCallReceived
                              ? 'success'
                              : callee.status.current === CallStatusType.OutboundCallNotAnswered ||
                                callee.status.current === CallStatusType.OutboundCallNotReceived
                                ? 'warning'
                                : 'secondary'
                        }
                      >
                        {getCallStatusLabel(callee.status.current, callee.status.prev)}

                      </Badge>
                    </div>

                    {
                      (
                        callee.status.current === CallStatusType.OutboundCallNotReceived ||
                        callee.status.current === CallStatusType.OutboundCallReceived
                      ) && (
                        <Button
                          variant="danger"
                          size="sm"
                          onClick={() => handleHangup(callee.callSid)}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                            width="16"
                            height="16"
                            fill="white"
                          >
                            <path d="M511.2 387l-23.25 100.8c-3.266 14.25-15.79 24.22-30.46 24.22C205.2 512 0 306.8 0 54.5c0-14.66 9.969-27.2 24.22-30.45l100.8-23.25C139.7-2.602 154.7 5.018 160.8 18.92l46.52 108.5c5.438 12.78 1.77 27.67-8.98 36.45L144.5 207.1c33.98 69.22 90.26 125.5 159.5 159.5l44.08-53.8c8.688-10.78 23.69-14.51 36.47-8.975l108.5 46.51C506.1 357.2 514.6 372.4 511.2 387z" />
                          </svg>
                        </Button>
                      )
                    }
                    {
                      (
                        callee.status.current === CallStatusType.OutboundCallCompleted ||
                        callee.status.current === CallStatusType.OutboundCallNotAnswered
                      ) && (
                        <Button
                          variant="success"
                          title="call again"
                          size="sm"
                          onClick={() => callAgain(callee.calledNumber)}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                            width="16"
                            height="16"
                            fill="white"
                          >
                            <path d="M511.2 387l-23.25 100.8c-3.266 14.25-15.79 24.22-30.46 24.22C205.2 512 0 306.8 0 54.5c0-14.66 9.969-27.2 24.22-30.45l100.8-23.25C139.7-2.602 154.7 5.018 160.8 18.92l46.52 108.5c5.438 12.78 1.77 27.67-8.98 36.45L144.5 207.1c33.98 69.22 90.26 125.5 159.5 159.5l44.08-53.8c8.688-10.78 23.69-14.51 36.47-8.975l108.5 46.51C506.1 357.2 514.6 372.4 511.2 387z" />
                          </svg>
                        </Button>
                      )
                    }

                  </ListGroup.Item>
                ))}
              </ListGroup>
            </div>
          </div>
          <div className="d-flex flex-column">
            <button
              style={{ backgroundColor: "var(--purple)", borderWidth: "0px" }}
              className="btn btn-secondary mb-2"
              role="button"
              onClick={() => {
                setShowOutboundModal(true);
              }}
            >
              Call Participant
            </button>


            <button
              className="btn btn-secondary"
              role="button"
              onClick={() => {
                setShowAddParticipantModal(true);
              }}
            >
              Add Interpreter
            </button>
          </div>
        </div>
      </div>
      <ModalAddOPIOperatorParticipant
        callType={CallType.Audio}
        show={showAddParticipantModal}
        handleShow={setShowAddParticipantModal}
        callinfo={callinfo}
      />
    </>
  );
}
